import PropTypes from 'prop-types';
import { unitToString } from '@/utils/unitUtils';
import CashFlowBarChart from '@/components/charts/CashFlowBarChart';

const CashFlowChartContainer = ({ data, label, plotColumn }) => {
  const plottable = data?.filter(result => result.plottable);
  const yearLabels = data?.find(result => result.category[1] === 'Year');
  const currentPlot = plottable?.find(p => `${p.category[0]}-${p.category[1]}` === plotColumn) || plottable?.[0];

  if (!plottable) {
    return null;
  }

  const category = currentPlot?.category[1];
  const unit = unitToString(currentPlot?.unit);
  const yAxisLabel = `${label ? `${label} - ` : ''}${category}\n${unit}/year`;

  return (
    <div className="h-full">
      <CashFlowBarChart data={currentPlot.data} labels={yearLabels.data} yAxisLabel={yAxisLabel} />
    </div>
  );
};

CashFlowChartContainer.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      plottable: PropTypes.bool,
      category: PropTypes.arrayOf(PropTypes.string),
      unit: PropTypes.object,
    }),
  ),
  label: PropTypes.string,
  plotColumn: PropTypes.string,
};

export default CashFlowChartContainer;
